/**
 * A unique ID for referring to a client of the bridge API.
 *
 * @description Can either be a producer or receiver of events.
 */

/**
 * Convert a string reference to a {@link ClientId}.
 * @param s
 * @returns client ID reference
 */
export var client = function client(s) {
  return s;
};

/**
 * Current state of a client. A client can either be:
 *
 * - Pending: still awaiting handshake from the current JS context & a specific sender ID
 * - Ready: handshake succeeded between sender & client - ready to communicate ✅
 *
 * Additionally, clients can be `local` or `remote`. A local client is one which can be immediately
 * invoked from the current JS context (e.g., a same-origin `iframe`). A remote client is one which
 * relies upon asynchronous message passing to communicate with the current JS context (e.g., a cross-
 * origin iframe which needs to be communicated with via {@link window.postMessage}).
 */